export default __webpack_public_path__ + "static/media/nexus-white-big.e8fac503.png";